import styled from "styled-components";
import LogoImg from "../../assets/images/logo/logo-2.png";
const Wrapper = styled.div``;
function LogoCircular({ height }) {
  return (
    <Wrapper>
      <img src={LogoImg} alt="Logo" height={height || "50px"} />
    </Wrapper>
  );
}

export default LogoCircular;
